import { initNavPanels } from '@scripts/nav-panels';

import { initHero, initHeroSlider } from './hero';
import { initHeroLoader } from './hero-loader';
import type { ProductPinDetail } from './product';
import { initProducts, productsPinDisabled } from './product';

// ヒーロー画像の取得計測を最速で始めるため最初に呼ぶ
initHeroLoader();

initHero();
initHeroSlider();
initProducts();
initNavPanels();

// 3Dレイヤーは重いので動的 import。3D バックルはプロダクト区間の作図枠へ
// 追従させる演出で、pin をやめた縦積み時は据え置き先が無い。そのため
// 「初めてピンモードに入った時」だけ読み込み、以後は破棄せず保持する
// (three に破棄処理が無く、リサイズごとの作り直しは重いため)。縦積み中の
// 非表示は product-model 側が soak:products-pin を見て行う。モバイル等で
// 一度もピンしなければ 3D は読み込まれない
const canvas = document.querySelector<HTMLCanvasElement>('[data-webgl]');
if (canvas) {
  let loaded = false;
  const ensureThree = () => {
    if (loaded) return;
    loaded = true;
    import('@scripts/three')
      .then(({ initThree }) => initThree(canvas))
      .catch((error) => {
        console.error('Failed to init 3D layer:', error);
        canvas.remove();
      });
  };

  // 初回ロード時にピンしているなら即用意 (この時点の soak:products-pin は
  // 発火済みでリスナーが間に合わないため、初期状態は明示的に見る)
  if (!productsPinDisabled) ensureThree();
  // リサイズでピンモードへ入ったら用意する
  window.addEventListener('soak:products-pin', (event) => {
    if ((event as CustomEvent<ProductPinDetail>).detail.pinned) ensureThree();
  });
}
